import { PackageProvider } from '@openx/components-package/utils/context/PackageContext';
import { OPEN_AUDIENCE_ORG_NAME } from '@openx/utils/services/config';
import type { PropsWithChildren } from 'react';
import { useAuth } from '../../components/AuthContext/context';
import { packageConfig } from './packageConfig';

export const PackageProviderWithAuth = ({ children }: PropsWithChildren) => {
  const { session } = useAuth();

  const isOaSuborg = session?.account?.name !== OPEN_AUDIENCE_ORG_NAME;

  return <PackageProvider packageConfig={{ ...packageConfig, isOaSuborg }}>{children}</PackageProvider>;
};
